import React, { createContext, useState, useEffect } from "react";
import { array } from "yup";

// VOLCANO
import volcano1 from "../assets/img/landing-toro/volcano/azul.png";
import volcano2 from "../assets/img/landing-toro/volcano/blanco.png";
import volcano3 from "../assets/img/landing-toro/volcano/carbon.png";
import volcano4 from "../assets/img/landing-toro/volcano/cinza.png";
import volcano5 from "../assets/img/landing-toro/volcano/cristal.png";
import volcano6 from "../assets/img/landing-toro/volcano/plata.png";
import volcano7 from "../assets/img/landing-toro/volcano/rojo.png";

// FREEDOM
import freedom1 from "../assets/img/landing-toro/freedom/branco.png";
import freedom2 from "../assets/img/landing-toro/freedom/carbon.png";
import freedom3 from "../assets/img/landing-toro/freedom/granie.png";
import freedom4 from "../assets/img/landing-toro/freedom/prata.png";
import freedom5 from "../assets/img/landing-toro/freedom/rojo.png";

// S-DESIGN
import sdesign1 from "../assets/img/landing-toro/s-design/blanco.png";
import sdesign2 from "../assets/img/landing-toro/s-design/gris.png";
import sdesign3 from "../assets/img/landing-toro/s-design/negro.png";
import sdesign4 from "../assets/img/landing-toro/s-design/rojo.png";

// S-DESIGN
import ultra1 from "../assets/img/landing-toro/ultra/azul.png";
import ultra2 from "../assets/img/landing-toro/ultra/blanco.png";
import ultra3 from "../assets/img/landing-toro/ultra/carbon.png";
import ultra4 from "../assets/img/landing-toro/ultra/cinza.png";
import ultra5 from "../assets/img/landing-toro/ultra/rojo.png";

import toro_seguridad_01 from "../assets/img/landing-toro/ficha_toro/seguridad/1.png";
import toro_seguridad_freedom02 from "../assets/img/landing-toro/ficha_toro/seguridad/2-freedom.png";
import toro_seguridad_sdesign02 from "../assets/img/landing-toro/ficha_toro/seguridad/2-s-design.png";
import toro_seguridad_ultra02 from "../assets/img/landing-toro/ficha_toro/seguridad/2-ultra.png";
import toro_seguridad_03 from "../assets/img/landing-toro/ficha_toro/seguridad/3.png";
import toro_seguridad_04 from "../assets/img/landing-toro/ficha_toro/seguridad/4.png";
import toro_seguridad_05 from "../assets/img/landing-toro/ficha_toro/seguridad/5.png";

import toro_confort_01 from "../assets/img/landing-toro/ficha_toro/confort/1.png";
import toro_confort_02 from "../assets/img/landing-toro/ficha_toro/confort/2.png";
import toro_confort_03 from "../assets/img/landing-toro/ficha_toro/confort/3.png";
import toro_confort_04 from "../assets/img/landing-toro/ficha_toro/confort/4.png";

//Crear el context
export const VehiculosContext = createContext();

//provider es donde se encuentran las funciones y state
const VehiculosProvider = (props) => {
  const [vehiculos, setVehiculos] = useState("VOLCANO");

  const arrayVehiculos = [
    {
      id: "VOLCANO",
      name: "VOLCANO",
      img: [volcano1, volcano2, volcano3, volcano4],
      seguridad: [],
      confort: [],
      seguridad23: [
        { foto: toro_seguridad_01, titulo: "7 Airbags (frontales, laterales, cortina y rodilla conductor)." },
        { foto: toro_seguridad_freedom02, titulo: "Alarma perimétrica." },
        { foto: toro_seguridad_03, titulo: "Sistema de asistencia al arranque en pendiente (HLA)." },
        { foto: toro_seguridad_04, titulo: "Sistema de frenos ABS con EBD." },
      ],
      tecnologia23: [
        { foto: toro_confort_01, titulo: "Climatizador automático bi-zona." },
        { foto: toro_confort_02, titulo: "Dirección asistida eléctricamente." },
        { foto: toro_confort_03, titulo: "Apertura y encendido sin llave." },
        { foto: toro_confort_04, titulo: "Volante regulable en altura y profundidad." },
      ],
    },
    {
      id: "FREEDOM",
      name: "FREEDOM",
      img: [freedom1, freedom2, freedom3, freedom4, freedom5],
      seguridad: [],
      confort: [],
      seguridad23: [
        { foto: toro_seguridad_01, titulo: "7 Airbags (frontales, laterales, cortina y rodilla conductor)." },
        { foto: toro_seguridad_freedom02, titulo: "Alarma perimétrica." },
        { foto: toro_seguridad_03, titulo: "Sistema de asistencia al arranque en pendiente (HLA)." },
        { foto: toro_seguridad_04, titulo: "Sistema de frenos ABS con EBD." },
      ],
      tecnologia23: [
        { foto: toro_confort_01, titulo: "Climatizador automático bi-zona." },
        { foto: toro_confort_02, titulo: "Dirección asistida eléctricamente." },
        { foto: toro_confort_03, titulo: "Sistema 'Follow Me Home'." },
        { foto: toro_confort_04, titulo: "Volante regulable en altura y profundidad." },
      ],
    },
    {
      id: "S-DESIGN",
      name: "S-DESIGN",
      img: [sdesign1, sdesign2, sdesign3, sdesign4],
      seguridad: [],
      confort: [],
      seguridad23: [
        { foto: toro_seguridad_01, titulo: "7 Airbags (frontales, laterales, cortina y rodilla conductor)." },
        { foto: toro_seguridad_sdesign02, titulo: "Alarma perimétrica." },
        { foto: toro_seguridad_03, titulo: "Sistema de asistencia al arranque en pendiente (HLA)." },
        { foto: toro_seguridad_04, titulo: "Sistema de frenos ABS con EBD." },
      ],
      tecnologia23: [
        { foto: toro_confort_01, titulo: "Climatizador automático bi-zona." },
        { foto: toro_confort_02, titulo: "Dirección asistida eléctricamente." },
        { foto: toro_confort_03, titulo: "Apertura y encendido sin llave." },
        { foto: toro_confort_04, titulo: "Volante regulable en altura y profundidad." },
      ],
    },
    {
      id: "ULTRA",
      name: "ULTRA",
      img: [ultra1, ultra2, ultra3, ultra4, ultra5],
      seguridad: [],
      confort: [],
      seguridad23: [
        { foto: toro_seguridad_01, titulo: "7 Airbags (frontales, laterales, cortina y rodilla conductor)." },
        { foto: toro_seguridad_ultra02, titulo: "Alarma perimétrica." },
        { foto: toro_seguridad_03, titulo: "Sistema de asistencia al arranque en pendiente (HLA)." },
        { foto: toro_seguridad_04, titulo: "Sistema de frenos ABS con EBD." },
      ],
      tecnologia23: [
        { foto: toro_confort_01, titulo: "Climatizador automático bi-zona." },
        { foto: toro_confort_02, titulo: "Dirección asistida eléctricamente." },
        { foto: toro_confort_03, titulo: "Sistema 'Follow Me Home'." },
        { foto: toro_confort_04, titulo: "Volante regulable en altura y profundidad." },
      ],
    },
  ];

  const marcaLanding = "Fiat";
  const modeloLanding = "Toro";

  return (
    <VehiculosContext.Provider
      value={{
        vehiculos,
        setVehiculos,
        arrayVehiculos,
        marcaLanding,
        modeloLanding,
      }}
    >
      {props.children}
    </VehiculosContext.Provider>
  );
};

export default VehiculosProvider;
